// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleWithBody_container__9NFWY","title":"TitleWithBody_title__eVGn7"};